import React, { useState } from "react";
import { FormattedHTMLMessage } from "react-intl";
import User from "../../../../../components/User";
import { IProps } from "./interfaces";

import {
    Row,
    Top,
    TopLeft,
    Key,
    TopRight,
    Messages,
    Original,
    TranslationMessage,
    UserWrapper,
    TokenState,
    Preview,
} from "./styles";
import TranslationTextArea from "./TranslationTextArea";

const TokenField = ({
    token,
    responsibleUser,
    user,
    saveToken,
    status,
    getToken,
    approveTranslation,
    approvedBy,
    sourceLanguage,
}: IProps) => {
    const [isCorrecting, setIsCorrecting] = useState(false);
    const isHtmlToken = token[sourceLanguage]?.indexOf("<") >= 0;
    return (
        <Row key={token._id}>
            <Top>
                <TopLeft>
                    <Key>{token.key}</Key>
                    {token.translationToken?.merged ? (
                        <TokenState
                            isMerged={
                                token.translationToken.merged >
                                (token.translationToken.updated || token.translationToken.created)
                            }
                        >
                            {token.translationToken.merged >
                            (token.translationToken.updated || token.translationToken.created)
                                ? "Merged"
                                : "Modified"}
                        </TokenState>
                    ) : (
                        token.translationToken && "Unmerged"
                    )}
                </TopLeft>
                <TopRight>
                    {!isCorrecting && ((responsibleUser && responsibleUser._id !== user._id) || (!responsibleUser && !!token.translationToken?.value)) && (
                        <>
                            {approvedBy.findIndex(u => u.user === user._id) === -1 &&
                                (status < 4 || approvedBy.length === 0) && (
                                    <button className="button" onClick={() => approveTranslation(token)}>
                                        Approve
                                    </button>
                                )}
                            <button className="button button--light" onClick={() => setIsCorrecting(!isCorrecting)}>
                                Edit
                            </button>
                        </>
                    )}
                    {responsibleUser && (
                        <UserWrapper>
                            <User user={responsibleUser} noTab />
                        </UserWrapper>
                    )}
                </TopRight>
            </Top>
            <Messages>
                <TranslationMessage>
                    <Original value={token[sourceLanguage] || ""} rows={Math.ceil(token[sourceLanguage]?.length / 60)}></Original>
                    <Preview>
                        {isHtmlToken && (
                            <FormattedHTMLMessage id={token.key + "_sample"} defaultMessage={token[sourceLanguage]}/>
                        )}
                    </Preview>
                </TranslationMessage>
                <TranslationMessage>
                    <TranslationTextArea
                        approvedBy={approvedBy}
                        isCorrecting={isCorrecting}
                        disabled={!isCorrecting && token.translationToken && user._id !== token.translationToken?.user}
                        original={token[sourceLanguage] || ""}
                        saveToken={async value => {
                            setIsCorrecting(false);
                            await saveToken(token, value);
                        }}
                        translationToken={token.translationToken}
                        maxLength={token.maxLength}
                        getToken={() => {
                            getToken(token);
                        }}
                    />
                    <Preview>
                        {isHtmlToken && (
                            <FormattedHTMLMessage id={token.key + "_sample2"} defaultMessage={token.translationToken?.value || ""}/>
                        )}
                    </Preview>
                </TranslationMessage>
            </Messages>
        </Row>
    );
};

export default TokenField;

